'use client';
import { Component, PropsWithChildren } from 'react';

import ErrorView from 'components/Error';
import { ddlog } from 'utils/miscellaneous';

interface IState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<PropsWithChildren, IState> {
  public constructor(props: PropsWithChildren) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  public static getDerivedStateFromError(error: Error) {
    ddlog.warn('ErrorBoundary - uncaught error', { error });
    return { hasError: true, error };
  }

  public render() {
    if (this.state.hasError) {
      return <ErrorView error={this.state.error} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
